jQuery(document).ready(function ($) {
  //############################################//
  //###*****   Featured article drawers
  //############################################//

  const mq = window.matchMedia("(min-width: 768px)");
  if (mq.matches) {
    $(".m-blog-post-selector").hover(
      function () {
        $(".m-blog-post-selector__text-float", this)
          .stop(true, true)
          .delay(100)
          .animate({ bottom: "0" }, 200)
          .addClass("open");
      },
      function () {
        $(".m-blog-post-selector__text-float", this)
          .stop(true, true)
          .delay(100)
          .animate({ bottom: "-70" }, 200)
          .removeClass("open");
      }
    );
  }




});
